import { render } from "./FormFooter.vue?vue&type=template&id=59fb7c34&scoped=true"
import script from "./FormFooter.vue?vue&type=script&lang=js"
export * from "./FormFooter.vue?vue&type=script&lang=js"

import "./FormFooter.vue?vue&type=style&index=0&id=59fb7c34&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fb7c34"]])

export default __exports__